import { ReactNode } from 'react';
import styles from './InfoBubble.module.css';
import { useModal } from '@modal/Hooks/UseModal';
import { Info } from '@gds/Icons/Paths/Info';

type InfoBubbleProps = {
  header: ReactNode;
  content: string | undefined;
};

export const InfoBubble = ({ header, content }: InfoBubbleProps) => {
  const { openModal } = useModal();

  const handleOpenModal = () => {
    openModal(<div dangerouslySetInnerHTML={{ __html: content || '' }} />, {
      header: header,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <span>
      <Info className={styles.infoIcon} fontSize={20} onClick={handleOpenModal} />
    </span>
  );
};
